import { defineSlotRecipe } from '@chakra-ui/react';

/*
 * v3 port notes:
 * - v2's `CircularProgress` took any `sizes` token (`size={4}`); v3's
 *   `ProgressCircle` only has the built-in named scale, which starts at
 *   `xs` (24px). `3xs` (12px) and `2xs` (16px) cover the small inline
 *   spinners (tags, inputs, table actions) the built-in scale has no step
 *   for.
 * - Size vars go on the `circle` slot, not `root`: that's where the
 *   built-in variants set them, so a var on the root would be shadowed.
 * - The default is `xs` (24px), matching the old wrapper default of
 *   `size={6}`, instead of the built-in `md` (40px).
 * - Colors come from the theme's line tokens instead of the built-in gray
 *   `colorPalette` (a near-black arc): the brand indigo arc matches
 *   `Spinner`'s `primary` variant, on a `border.subtle` track.
 *   `MCircularProgress`'s `color`/`trackColor` props still override them.
 */

const progressCircleTheme = defineSlotRecipe({
  slots: ['root', 'circle', 'circleTrack', 'circleRange', 'label', 'valueText'],
  base: {
    circleTrack: {
      '--track-color': 'colors.border.subtle',
    },
    circleRange: {
      stroke: 'border.accent',
    },
  },
  variants: {
    size: {
      '3xs': {
        circle: {
          '--size': 'sizes.3',
          '--thickness': '1px',
        },
      },
      '2xs': {
        circle: {
          '--size': 'sizes.4',
          '--thickness': '2px',
        },
      },
      // Declared (but empty) so `defaultVariants` below can reference it —
      // the built-in's own `xs` (24px / 4px) is used as-is.
      xs: {},
    },
  },
  defaultVariants: {
    size: 'xs',
  },
});

export default progressCircleTheme;
